module.exports = __webpack_public_path__ + "static/skubacover-1eaa4df5441914c58ed97857ca8b7d03.jpg";